export const PlanCategory = {
  Bundle: 'bundle',
  FeedingPlan: 'feeding_plan',
} as const
export type PlanCategory = typeof PlanCategory[keyof typeof PlanCategory]
